/* eslint-disable one-var, one-var-declaration-per-line, prefer-destructuring, import/no-extraneous-dependencies */

import getKey from 'lodash/get';

import React, { Component, PureComponent } from 'react';
import styled, { css } from 'styled-components';

import QueryComponent from 'hive-admin/src/components/Query';

import { renderCurrency } from './SystemCountry';

import Types from '../modules/types';

import tests from '../helpers/tests';

import {
  formatIndexAmount,
  formatOrderStatus,
} from './Links';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ChartWrapper = styled.div`
  position: relative;
  display: flex;
  height: 200px;
`;

const TypeGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const TypeAmounts = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  text-align: center;
  flex: 1;
`;

const TypeAmountInfo = styled.div`
  display: flex;
  height: 70px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`;

const TypeAmountInfoLabel = styled.div`
  display: block;
  text-align: center;
`;

const TypeAmountInfoValue = styled.div`
  display: block;
  text-align: center;
`;

const TypeAmount = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1;
  position: relative;
  max-width: 30px;
  padding-left: 5px;
  cursor: pointer;
  &:first-child {
    max-width: 25px;
    padding-left: 0px;
  }
`;

const TypeAmountChart = styled.div`
  display: flex;
  background: rgb(243, 243, 243);
  height: 0px;
  width: 100%;
  transition:
    transform 800ms cubic-bezier(0.230, 1.000, 0.320, 1.000),
    height 800ms cubic-bezier(0.230, 1.000, 0.320, 1.000),
    background 200ms cubic-bezier(0.230, 1.000, 0.320, 1.000);

  ${({ active, theme }) => active && css`background: linear-gradient(
    to top,
    ${theme.less.primaryColor},
    ${theme.less.secondaryColor}
  );`}

  /* ${({ active, theme }) => active && css`
    background: ${theme.less.secondaryColor};
  `} */

  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;

const TypeAmountChartBottomLine = styled.div`
  display: flex;
  height: 1px;
  width: 100%;
  background: rgb(243, 243, 243);
  ${({ active }) => active && css`
    background: transparent;
  `}
`;

const TypeTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-size: 12px;
`;

const TypeTitleText = styled.div`
  display: block;
  text-align: center;
  padding: 5px;
`;

const DataWrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: -5px;
  margin-top: 5px;
  margin-bottom: 25px;
`;

const DataItem = styled.div`
  display: flex;
  flex: 1 1 ${({ minWidth = 140 }) => minWidth}px;
  flex-direction: column;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.less.borderColor};
  margin: 5px;
  /* border-radius: ${({ theme }) => theme.less.borderRadius}; */
  border-radius: 15px;
  line-height: 100%;
`;

const DataItemLabel = styled.div`
  display: flex;
  .anticon {
    color: ${({ theme }) => theme.less.textColor};
  }
`;

const DataItemLabelText = styled.span`
  opacity: 0.4;
`;

const DataItemValue = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 15px;
  padding-bottom: 4px;
`;

const DataItemValueNumber = styled.div.attrs(
  // eslint-disable-next-line arrow-body-style
  ({ value }) => {
    return {
      style: {
        opacity: value === 0 ? 0.1 : 1,
      },
    };
  },
)`
  display: flex;
  font-size: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.less.primaryColor};
`;

const DataItemValueUnit = styled.div`
  font-size: 14px;
  transform: translateY(5px);
  margin-right: 5px;
`;

const DataItemValueReminder = styled.div`
  font-size: 14px;
  transform: translateY(5px);
  margin-right: 5px;
`;

export class TransactionsChartTypeGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAmountKey: props.statuses[0],
      peekAmountKey: null,
    };
  }

  setAmountKey(amountKey, asSelected = true) {
    this.setState((state) => {
      if (asSelected) {
        return {
          selectedAmountKey: state.selectedAmountKey === amountKey
          ? null
          : amountKey,
        };
      }
      return { peekAmountKey: amountKey };
    });
  }

  render() {
    const { label, statuses, data, max } = this.props;
    const { selectedAmountKey, peekAmountKey } = this.state;
    const activeStatus = peekAmountKey || selectedAmountKey;
    return (
      <TypeGroupWrapper>
        <TypeAmountInfo>
          {
            activeStatus
            ? (
                <>
                  <TypeAmountInfoLabel>
                    {
                      formatOrderStatus(
                        activeStatus === label
                        ? activeStatus
                        : activeStatus.replace(`${label}_`, '')
                      )
                    }
                  </TypeAmountInfoLabel>
                  <TypeAmountInfoValue>
                    {
                      formatIndexAmount(
                        getKey(
                          data,
                          `${activeStatus}.sum`,
                          0,
                        ),
                      )
                    }
                  </TypeAmountInfoValue>
                </>
              )
            : null
          }
        </TypeAmountInfo>
        <TypeAmounts>
          {
            statuses.map((status) => {
              const value = getKey(
                data,
                `${status}.sum`,
                0,
              );
              const scale = value / max;
              return (
                <TypeAmount
                  key={status}
                  onMouseEnter={() => this.setAmountKey(status, false)}
                  onMouseLeave={() => this.setAmountKey(null, false)}
                  onClick={() => this.setAmountKey(status, true)}
                >
                  <TypeAmountChart
                    style={{
                      height: `${Types.getRoundedAmount(scale * 100)}%`,
                    }}
                    active={status === activeStatus}
                  />
                  <TypeAmountChartBottomLine
                    active={status === activeStatus}
                  />
                </TypeAmount>
              );
            })
          }
        </TypeAmounts>
        <TypeTitle>
          <TypeTitleText>
            {label}
          </TypeTitleText>
        </TypeTitle>
      </TypeGroupWrapper>
    );
  }
}

export default class TransactionsChart extends Component {
  constructor(props) {
    super(props);
    this.state = { data: {}, max: 0 };
    this.state = {
      max: this.getMax(this.props.data, this.state),
      data: this.getData(this.props.data, this.state),
    };
  }

  getMax(data, state) {
    if (!data) {
      return state.max || 0;
    }
    return Math.max(...Object.values(data).map(values => values.sum));
  }

  getData(data, state) {
    if (!data) {
      return state.data || {};
    }
    return data;
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(props) {
    if (this.props.data !== props.data) {
      this.setState(state => ({
        max: this.getMax(props.data, state),
        data: this.getData(props.data, state),
      }));
    }
  }

  renderData() {
    return (
      <DataWrapper>
        {
          [{
            id: 'success',
            statuses: ['DELIVERED'],
            label: (
              (
                this.props.viewer?.storeType === 'RESELLER'
                // || this.props.viewer?.storeType === 'REFERRAL'
              )
              ? 'Realized Revenue'
              : 'Realized Sales'
            ),
          }, {
            id: 'upcoming',
            statuses: ['NEW', 'DELIVERY'],
            label: (
              (
                this.props.viewer?.storeType === 'RESELLER'
                // || this.props.viewer?.storeType === 'REFERRAL'
              )
              ? 'Upcoming Revenue'
              : 'Upcoming Sales'
            ),
          }, {
            id: 'total',
            statuses: ['NEW', 'DELIVERY', 'DELIVERED'],
            label: (
              (
                this.props.viewer?.storeType === 'RESELLER'
                // || this.props.viewer?.storeType === 'REFERRAL'
              )
              ? 'Total Revenue'
              : 'Total Sales'
            ),
          }].map(({ id, label, statuses }) => {
            const value = statuses.reduce(
              (agr, status) => (
                agr + ((this.state.data[status] || {}).sales || 0)
              ),
              0,
            );
            const [
              valueFormattedInt,
              valueFormattedReminder,
            ] = Types.decimalize(value).split('.');
            return (
              <DataItem key={id} minWidth={200}>
                <DataItemLabel>
                  <DataItemLabelText>
                    {label}
                  </DataItemLabelText>
                </DataItemLabel>
                <DataItemValue>
                  <DataItemValueUnit>
                    {renderCurrency()}
                  </DataItemValueUnit>
                  <DataItemValueNumber
                    value={1}
                  >
                    {valueFormattedInt}
                    <DataItemValueReminder>
                      {`.${valueFormattedReminder}`}
                    </DataItemValueReminder>
                  </DataItemValueNumber>
                </DataItemValue>
              </DataItem>
            );
          })
        }
      </DataWrapper>
    );
  }

  render() {
    const { viewer } = this.props;
    return (
      <Wrapper>
        <ChartWrapper>
          {
            Types.ORDER_STATUS_CHART.map((statuses, i) => {
              const label = Types.ORDER_STATUS_CHART_LABELS[i];
              return (
                <TransactionsChartTypeGroup
                  // eslint-disable-next-line react/no-array-index-key
                  key={i}
                  label={label}
                  statuses={statuses}
                  data={this.state.data}
                  max={this.state.max}
                />
              );
            })
          }
        </ChartWrapper>
        {
          (
            viewer
            && (
              viewer.role === 'SELLER'
              || (
                viewer.role === 'ADMIN'
                && !tests.viewerIsAdminAndDoesNotHavePermission(
                  'ordersSalesChartView'
                )(this.props)
              )
            )
          )
          ? this.renderData()
          : null
        }
      </Wrapper>
    );
  }
}

export class Query extends PureComponent {
  static defaultProps = {
    ChartComponent: TransactionsChart,
  }

  extractData = res => (res && res.data ? res.data : {})

  render() {
    const { url, client, ChartComponent } = this.props;
    return (
      <QueryComponent
        url={url}
        client={client}
        method="GET"
        extractData={this.extractData}
      >
        {({ data }) => (
          <ChartComponent
            data={data}
            viewer={this.props.viewer}
          />
        )}
      </QueryComponent>
    );
  }
}
